<template>
  <div v-if="copy && header">
    <div>
      <template v-if="header.format">
        <!-- <v-checkbox v-model="copy.bold" label="Bold" @change="updateSelected" /> -->
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="bold"
            v-model="copy.bold"
            @change="updateSelected"
          />
          <label for="bold">bold</label>
        </div>
        <!-- <v-checkbox v-model="copy.italic" label="Italic" @change="updateSelected" /> -->
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="italic"
            v-model="copy.italic"
            @change="updateSelected"
          />
          <label for="italic">italic</label>
        </div>
        <!-- <v-checkbox v-model="copy.underline" label="Underline" @change="updateSelected" /> -->
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="underline"
            v-model="copy.underline"
            @change="updateSelected"
          />
          <label for="underline">underline</label>
        </div>
      </template>
      <!-- <v-text-field
        v-if="header.size"
        type="number"
        label="Size:"
        v-model.number="copy.size"
        @input="updateSelectedDebounce"
        outline
      />-->
      <div class="templateHeaderBlock" v-if="header.size">
        <span>Size:</span>
        <input
          type="number"
          v-model.number="copy.size"
          @input="updateSelectedDebounce"
        />
      </div>
      <!-- <v-select
        v-model="copy.align"
        :items="aligns"
        item-value="value"
        item-text="label"
        label="Align"
        @change="updateSelected"
        outline
        v-if="header.align"
      />-->
      <div class="templateHeaderBlock" v-if="header.align">
        <select id="listAlign" v-model="copy.align" @change="updateSelected">
          <option
            v-for="align in aligns"
            :key="align.value"
            :value="align.value"
          >
            {{ align.label }}
          </option>
        </select>
      </div>
      <template v-if="header.list">
        <!-- <v-select
          v-model="copy.type"
          :items="types"
          item-value="value"
          item-text="label"
          label="List type"
          @change="updateSelected"
          outline
        />-->
        <div class="templateHeaderBlock">
          <select id="listType" v-model="copy.type" @change="updateSelected">
            <option v-for="type in types" :key="type.value" :value="type.value">
              {{ type.label }}
            </option>
          </select>
        </div>
        <!-- <v-select
          v-model="copy.typeordered"
          :items="typesOrdered"
          item-value="value"
          item-text="label"
          label="Ordered list type"
          @change="updateSelected"
          outline
        />-->
        <div class="templateHeaderBlock">
          <select
            id="listTypeOrdered"
            v-model="copy.typeordered"
            @change="updateSelected"
          >
            <option
              v-for="typeordered in typesOrdered"
              :key="typeordered.value"
              :value="typeordered.value"
            >
              {{ typeordered.label }}
            </option>
          </select>
        </div>
      </template>
      <div class="templateHeaderBlock" v-if="header.omit">
        <input
          type="checkbox"
          id="omit"
          v-model="copy.omit"
          @change="updateSelected"
        />
        <label for="omit">omit</label>
      </div>
      <div class="templateHeaderBlock" v-if="header.omit && copy.omit">
        <input
          type="checkbox"
          id="omitDefault"
          v-model="copy.omitDefault"
          @change="updateSelected"
        />
        <label for="omitDefault">omitted by default</label>
      </div>
      <div class="templateHeaderBlock" v-if="header.required">
        <input
          type="checkbox"
          id="required"
          v-model="copy.required"
          @change="updateSelected"
        />
        <label for="required">required</label>
      </div>
      <div class="templateHeaderBlock" v-if="header.space">
        <input
          type="checkbox"
          id="space"
          v-model="copy.space"
          @change="updateSelected"
        />
        <label for="space">space</label>
      </div>
      <div class="templateHeaderBlock" v-if="header.timeOnly">
        <input
          type="checkbox"
          id="timeOnly"
          v-model="copy.timeOnly"
          @change="updateSelected"
        />
        <label for="timeOnly">timeOnly</label>
      </div>
      <template v-if="header.cell">
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="border"
            v-model="copy.border"
            @change="updateSelected"
          />
          <label for="border">border</label>
        </div>
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="pad"
            v-model="copy.pad"
            @change="updateSelected"
          />
          <label for="pad">pad</label>
        </div>
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="shade"
            v-model="copy.shade"
            @change="updateSelected"
          />
          <label for="shade">shade</label>
        </div>
      </template>
      <div class="templateHeaderBlock" v-if="header.section">
        <input
          type="checkbox"
          id="keepTogether"
          v-model="copy.keepTogether"
          @change="updateSelected"
        />
        <label for="keepTogether">keep together</label>
      </div>
      <div
        class="templateHeaderBlock"
        v-if="header.additionItems && header.additionItems.length"
      >
        <span>Add item:&#160;</span>
        <select id="additionalItem" v-model="additionItem">
          <option
            v-for="(additionItem, index) in header.additionItems"
            :key="index"
            :value="additionItem"
          >
            {{ additionItem }}
          </option>
        </select>
        <v-btn @click="addAdditionItem" small>add</v-btn>
      </div>
      <div class="templateHeaderBlock" v-if="header.col">
        <span>width</span>
        <input
          type="number"
          v-model.number="copy.width"
          @input="updateSelectedDebounce"
        />
      </div>
      <div class="templateHeaderBlock" v-if="header.name">
        <span>name</span>
        <input
          type="text"
          v-model="copy.name"
          @input="updateSelectedDebounce"
        />
      </div>
      <div class="templateHeaderBlock" v-if="header.value">
        <span>default</span>
        <input
          type="text"
          v-model="copy.value"
          @input="updateSelectedDebounce"
        />
      </div>
      <template v-if="header.lookup">
        <div class="templateHeaderBlock">
          <input
            type="checkbox"
            id="noEscape"
            v-model="copy.noEscape"
            @change="updateSelected"
          />
          <label for="noEscape">no escape</label>
        </div>
        <div class="templateHeaderBlock">
          <span>data</span>
          <select v-model="copy.name" @change="updateSelected">
            <option
              v-for="(reportDataItem, index) in reportDataItems"
              :key="index"
              :value="reportDataItem"
            >
              {{ reportDataItem }}
            </option>
          </select>
        </div>
      </template>
      <template v-if="header.snippet">
        <div class="templateHeaderBlock">
          <span>data</span>
          <select v-model="copy.snippet" @change="updateSelected">
            <option value="0">Not selected</option>
            <option
              v-for="(snippet, index) in snippets"
              :key="index"
              :value="snippet.id"
            >
              {{ snippet.name }}
            </option>
          </select>
        </div>
        <div class="templateHeaderBlock" v-if="copy.snippet">
          <router-link
            :to="{ name: 'snippet', params: { id: copy.snippet.id } }"
            >Go to snippet</router-link
          >
        </div>
      </template>
      <template v-if="header.navigation">
        <v-btn :disabled="!header.moveUp" @click="move(true)" small>
          <v-icon>keyboard_arrow_up</v-icon>Move up
        </v-btn>
        <v-btn :disabled="!header.moveDown" @click="move(false)" small>
          <v-icon>keyboard_arrow_down</v-icon>Move down
        </v-btn>
      </template>
      <template v-if="header.section">
        <v-btn :disabled="!header.absorbUp" @click="absorb(true)" small
          >Absorb up</v-btn
        >
        <v-btn :disabled="!header.absorbDown" @click="absorb(false)" small
          >Absorb down</v-btn
        >
      </template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="header.remove"
            @click="remove"
            color="error"
            v-on="on"
            small
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>Remove</span>
      </v-tooltip>
      <v-btn @click="removeSection" v-if="header.removeSection" small
        >Move below section</v-btn
      >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="header.parentid"
            @click="$emit('updateSelected', header.parentid)"
            v-on="on"
            small
            >Parent</v-btn
          >
        </template>
        <span>Go to parent</span>
      </v-tooltip>
    </div>
    <!-- <div v-if="header.inline">
      <textarea
        id="submitValueField"
        style="width:100%;"
        rows="5"
        v-model="copy.value"
        @input="updateSelectedDebounce"
      />
    </div>-->
    <div v-if="header.link">
      <textarea
        style="width: 100%"
        rows="1"
        v-model="copy.url"
        @change="updateSelectedDebounce"
      />
      <br />
      <textarea
        style="width: 100%"
        rows="1"
        v-model="copy.title"
        @change="updateSelectedDebounce"
      />
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Header",
  props: ["templateRevisionId", "selectedObjectId", "navigation"],
  data() {
    return {
      header: null,
      reportDataItems: [],
      snippets: [],
      copy: null,
      timerId: null,
      aligns: [
        { value: 0, label: "Left" },
        { value: 1, label: "Centre" },
        { value: 2, label: "Right" }
      ],
      types: [
        { value: "unordered", label: "unordered" },
        { value: "ordered", label: "ordered" }
      ],
      typesOrdered: [
        { value: "1", label: "1" },
        { value: "a", label: "a" },
        { value: "A", label: "A" },
        { value: "i", label: "i" },
        { value: "I", label: "I" }
      ],
      additionItem: null
    };
  },
  methods: {
    async fetchHeader() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templateRevisions/${this.templateRevisionId}/documentElement/navigations/${this.selectedObjectId}/header`
      );
      // console.log(response.data);
      this.header = response.data;
    },
    async fetchReportDataItems() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/reportDataItems`
      );
      // console.log(response.data);
      this.reportDataItems = response.data;
    },
    async fetchSnippets() {
      const response = await nbmlaw.get(
        `/cors/admin/document/snippets/type/normal`
      );
      // console.log(response.data);
      this.snippets = response.data;
    },
    updateSelectedDebounce() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.updateSelected();
      }, 750);
    },
    async updateSelected() {
      // console.log(this.copy);
      await nbmlaw.put(
        `/cors/admin/document/navigations/${this.navigation.id}/${this.copy.className}`,
        this.copy
      );
      // console.log(response.data);
      this.updateHeader();
    },
    async addAdditionItem() {
      await nbmlaw.post(
        `/cors/admin/document/navigations/${this.navigation.id}/${this.additionItem}`,
        null
      );
      // console.log(response.data);
      this.updateHeader();
    },
    updateHeader() {
      this.$emit("triggerRefresh");
      this.fetchHeader();
    },
    async move(up) {
      await nbmlaw.put(
        `/cors/admin/document/templateRevisions/${this.templateRevisionId}/documentElement/navigations/${this.navigation.id}/move/${up}`,
        null
      );
      // console.log(response.data);
      this.updateHeader();
    },
    async absorb(up) {
      await nbmlaw.put(
        `/cors/admin/document/templateRevisions/${this.templateRevisionId}/documentElement/navigations/${this.navigation.id}/absorb/${up}`,
        null
      );
      // console.log(response.data);
      this.updateHeader();
    },
    async remove() {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/document/templateRevisions/${this.templateRevisionId}/documentElement/navigations/${this.navigation.id}`
        );
        // console.log(response.data);
        this.$emit("updateSelected", this.header.parentid);
        this.updateHeader();
      }
    },
    async removeSection() {
      await nbmlaw.put(
        `/cors/admin/document/templateRevisions/${this.templateRevisionId}/documentElement/navigations/${this.navigation.id}/removeFromSection`,
        null
      );
      // console.log(response.data);
      this.updateHeader();
    }
  },
  watch: {
    header: {
      handler() {
        if (
          this.header &&
          this.header.additionItems &&
          this.header.additionItems.length
        ) {
          this.additionItem = this.header.additionItems[0];
        } else {
          this.additionItem = null;
        }
      }
    },
    navigation: {
      immediate: true,
      handler() {
        this.copy = this.navigation
          ? JSON.parse(JSON.stringify(this.navigation))
          : null;
      }
    },
    selectedObjectId: {
      immediate: true,
      handler() {
        if (this.selectedObjectId) {
          this.fetchHeader();
        } else {
          this.header = null;
        }
      }
    }
  },
  created() {
    this.fetchReportDataItems();
    this.fetchSnippets();
  }
};
</script>

<style>
.templateHeaderBlock {
  float: left;
  padding: 5px;
  background: #dddddd;
  margin-right: 5px;
}
</style>